import { supabase } from '@/integrations/supabase/client';

/**
 * Sends a notification to a group's linked Telegram chat (fire-and-forget).
 * Resolves the chat_id from the group's telegram_chat_id column.
 */
export const sendTelegramNotification = async (params: {
  groupId: string;
  title: string;
  message: string;
  type: string;
}): Promise<void> => {
  try {
    const { data, error } = await supabase.functions.invoke('send-telegram-notification', {
      body: {
        group_id: params.groupId,
        title: params.title,
        message: params.message,
        type: params.type,
      },
    });

    if (error) {
      console.warn('Telegram notification failed (non-blocking):', error.message);
    } else if (data?.skipped) {
      // No Telegram chat linked — silent skip
    } else if (data?.ok) {
      console.log('📨 Telegram notification sent');
    }
  } catch (err) {
    console.warn('Telegram notification error (non-blocking):', err);
  }
};
